import { render, staticRenderFns } from "./carData.vue?vue&type=template&id=260c4797&scoped=true&"
import script from "./carData.vue?vue&type=script&lang=js&"
export * from "./carData.vue?vue&type=script&lang=js&"
import style0 from "./carData.vue?vue&type=style&index=0&id=260c4797&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260c4797",
  null
  
)

export default component.exports